module.exports = __webpack_public_path__ + "img/symbol_4.6e084d74.png";